export default __webpack_public_path__ + "static/media/iconArrowLeft.76845c63.svg";